import React from "react";
import { CDBFooter, CDBBox, CDBBtn, CDBIcon } from "cdbreact";
import logo from "../../images/product-images/remove-bg/sahakar-jal.png";
import "../Footer/Footer.css";
import { NavLink } from "react-bootstrap";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <>
      <div className="content-container">
        <CDBFooter className="shadow">
          <CDBBox
            display="flex"
            flex="column"
            className="mx-auto py-2"
            style={{ width: "90%" }}
          >
            <CDBBox
              display="flex"
              justifyContent="between"
              className="flex-wrap"
            >
              <CDBBox>
                <a href="/" className="d-flex align-items-center p-0 text-dark">
                  <img alt="logo" src={logo} width={100} height={60} />
                </a>
              </CDBBox>

              <CDBBox>
                <p
                  id="headings"
                  className="h5 mb-1"
                  style={{ fontWeight: "600" }}
                >
                  Sahakar Jal
                </p>
                <CDBBox
                  flex="column"
                  display="flex"
                  style={{ cursor: "pointer", padding: "0" }}
                >
                  <NavLink to="www.google.com">About Us</NavLink>
                  <NavLink href="/ContactUs">Contact Us</NavLink>
                </CDBBox>
              </CDBBox>
              <CDBBox>
                <CDBBox>
                  <p
                    id="headings"
                    className="h5 mb-1"
                    style={{ fontWeight: "600" }}
                  >
                    Our Products
                  </p>
                  <CDBBox
                    flex="column"
                    display="flex"
                    style={{ cursor: "pointer", padding: "0" }}
                  >
                    <NavLink href="/">Packaged Drinking Water</NavLink>
                    <NavLink to="www.google.com">Beverages</NavLink>
                  </CDBBox>
                </CDBBox>
              </CDBBox>
              {/* <CDBBox>
            <p id="headings" className="h5 mb-1" style={{ fontWeight: '600' }}>
              Our Policies
            </p>
            <CDBBox display="flex" flex="column" style={{ cursor: 'pointer', padding: '0' }}>
              <NavLink href="/">Refund/Cancellation </NavLink>
              <NavLink href="/">Privacy Policy</NavLink>
              <NavLink href="/">Terms & Conditions </NavLink>
            </CDBBox>
          </CDBBox> */}
            </CDBBox>
            {/* <CDBBox
              display="flex"
              justifyContent="center"
              style={{ width: "100%" }}
              className="mx-auto mt-1"
            >
              <CDBBtn flat color="dark" className="mx-3 p-2">
                {/* <Link
                  onClick={() =>
                    (window.location = "mailto:avionaqua@gmail.com")
                  }
                > 
                  <CDBIcon fab icon="google" />
                {/* </Link> *
              </CDBBtn>
              <CDBBtn flat color="dark" className="p-2">
                {/* <Link>
                </Link> 
                  <CDBIcon fab icon="instagram" />
              </CDBBtn>
            </CDBBox> */}
            <br />
            <small className="text-center mt-2">
              <b>
                &trade; Sahakar Jal Pvt Ltd. March 2018. All rights reserved.
              </b>
            </small>
          </CDBBox>
        </CDBFooter>
      </div>
    </>
  );
};

export default Footer;
